import React from 'react';
import styled from 'styled-components';
import TwpaaCategoryTree from '../../Components/TwpaaCategoryTree';

const NewsCategory = {
  items: [
    {
      name: '最新消息',
      display: '最新消息',
      items: [
        {name: '重要公告', display: '重要公告', url: '/news/important/'},
        {name: '會務訊息', display: '會務訊息', url: '/news/internal/'},
        {name: '會外新訊', display: '會外新訊', url: '/news/external/'},
      ],
    },
    {
      name: '活動花絮',
      display: '活動花絮',
      url: '/news/activities/',
    },
    {
      name: '徵才看板',
      display: '徵才看板',
      url: '/news/jobs/',
    },
  ],
};

export default function NewsLayout(props) {
  return (
    <Wrapper>
      <div className="main">
        <div className="nav">
          <TwpaaCategoryTree root={NewsCategory} location={props.location} />
        </div>
        <div className="content">{props.children}</div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);

  & > .main {
    max-width: 1120px;
    margin: 20px auto;
    display: flex;
    align-items: flex-start;
    gap: 20px;

    & > .nav {
      margin-top: 60px;
      width: 240px;
    }

    & > .content {
      flex: 1;
      min-height: 300px;
      padding: 0 20px;
    }
  }

  @media only screen and (max-width: 768px) {
    & > .main {
      flex-direction: column;
      align-items: stretch;
      & > .nav {
        width: 100%;
        order: 10;
      }
    }
  }
`;
